// removed by extract-text-webpack-plugin
module.exports = {"ModalWrap":"ModalWrap--rV6nG","Modal":"Modal--13Sds","close":"close--1WwFY"};